import { render, staticRenderFns } from "./tableSort.vue?vue&type=template&id=229c7a80&scoped=true&"
import script from "./tableSort.vue?vue&type=script&lang=js&"
export * from "./tableSort.vue?vue&type=script&lang=js&"
import style0 from "./tableSort.vue?vue&type=style&index=0&id=229c7a80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c7a80",
  null
  
)

export default component.exports